<template>
  <transition name="toast">
    <div class="toast" :style="{ background: options.background }" v-show="isShow">
      <div class="toast-text" :style="{ color: options.color }" v-html="text"></div>
    </div>
  </transition>
</template>

<script>
const defaultOptions = {
  background: 'rgba(0,0,0,0.8)',
  color: '#fff',
}

export default {
  name: 'AppToast',
  data(){
    return {
      text: '',
      isShow: false,
      duration: 2500,
      options: defaultOptions,
    }
  },
  created(){
  },
  methods: {
    
  },
  computed: {
    
  },
}
</script>

<style scoped lang="less">
  .toast {
    display: block;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding: .28rem .32rem;
    min-width: 4rem;
    max-width: 4.8rem;
    text-align: center;
    background-color: rgba(0,0,0,.8);
    z-index: 999;
    border-radius: 12px;
    box-sizing: border-box;
    &-text {
      display: block;
      white-space: normal;
      word-break: break-all;
      line-height: 1.5;
      color: #eee;
      font-size: .28rem;
      // white-space: nowrap;
    }
  }
  .toast-enter-active, .toast-leave-active {
    transition: opacity 0.5s ease-in-out;
  }
  .toast-enter, .toast-leave-to {
    opacity: 0;
  }
</style>
